import { useQuery } from '@tanstack/react-query';
import { fetchUserDetails } from '../../apis/profile';
import { handleErrorResponse } from '../../utils/handleError';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useUserDetails = (patientId: any) => {
  const { data, isError, isLoading, isRefetching, error } = useQuery({
    queryKey: ['profile', patientId],
    queryFn: () => fetchUserDetails(patientId),
  });

  if (isError) {
    handleErrorResponse(error, 'Error Fetching User Details');
  }

  return {
    isLoading,
    isError,
    isRefetching,
    userDetails: data?.data || [],
  };
};

export default useUserDetails;
